import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../../UI/Button";
import Heading from "../../UI/Heading";
import { StyledWrap, StyledBtnWrap } from "./style";

type Props = {
  title: string;
  buttonText?: string;
  buttonEnable: boolean;
  handleButton?: () => void;
  icon?: any;
};

const PageHeader: FC<Props> = ({
  title,
  buttonText,
  buttonEnable,
  handleButton,
  icon,
}) => {
  return (
    <StyledWrap>
      <div>
        <Heading as="h4" mb="5px">
          {title}
        </Heading>
      </div>
      {buttonEnable && (
        <StyledBtnWrap>
          <Button iconSize="sm" ml="10px" onClick={handleButton}>
            {icon ? icon : null}
            {buttonText}
          </Button>
        </StyledBtnWrap>
      )}
    </StyledWrap>
  );
};

export default PageHeader;
